import { Component, OnInit, isDevMode, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services';
import { PartnerService } from '../../../../../services/partner.service';
import { RentalsService } from '../../../../../services/rentals.service';
import { PaymentService } from '../../../../../services/payment.service';

@Component({
  selector: 'app-rentals-settings',
  templateUrl: './rentals-settings.component.html',
  styleUrls: ['./rentals-settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RentalsSettingsComponent implements OnInit {
  public messaging: any = [];
  public general: any = [];
  public rentals: any = [];
  public plugins: any = [];
  public partner: any;
  public configuration: any = {};
  public loading: boolean = false;

  constructor(
    private translate: TranslateService,
    private helpersService: HelpersService,
    public partnerService: PartnerService,
    public rentalsService: RentalsService,
    private paymentService: PaymentService,
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();

    this.getConfiguration();
  }

  getConfiguration() {
    this.loading = true;
    this.rentalsService
      .getRentalConfiguration(this.helpersService.getPartnerId())
      .subscribe(
        (configuration) => {
          this.configuration = configuration;

          this.setupMenuOptions();

          if (this.partner.Country !== 'ZA' && this.partner.POSSystemID != 17) {
            this.general.push({
              title: this.translate.instant(
                'bikeshop.shop_setup.card_headers.in_app_payments',
              ),
              icon: 'hubtiger-stripe',
              classId: 'rental-inapp-payments',
              description: this.translate.instant(
                'bikeshop.shop_setup.card_description.in_app_payments',
              ),
              path: 'store/inapp-payment-configuration',
            });
          }
          this.loading = false;
        },
        (err) => {
          this.setupMenuOptions();
          if (this.partner.Country !== 'ZA') {
            this.general.push({
              title: this.translate.instant(
                'bikeshop.shop_setup.card_headers.in_app_payments',
              ),
              icon: 'hubtiger-stripe',
              classId: 'rental-app-payments',
              description: this.translate.instant(
                'bikeshop.shop_setup.card_description.in_app_payments',
              ),
              path: 'store/inapp-payment-configuration',
            });
          }
          this.loading = false;
        },
      );
  }

  setupMenuOptions() {
    this.setupMessagingOptions();
    this.setupGeneralOptions();
    this.setupPluginsOptions();
    this.setupRentalsOptions();
  }

  setupMessagingOptions() {
    this.messaging = [
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.message_templates_short',
        ),
        icon: 'hubtiger-message-template',
        classId: 'rental-message-templates',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.message_templates',
        ),
        path: 'store/rentals/message-templates',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.message_bundles',
        ),
        icon: 'hubtiger-message-bundle',
        classId: 'rental-message-bundle',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.message_bundles',
        ),
        path: 'store/rentals/purchase-messaging-bundle',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.whatsapp_integration',
        ),
        icon: 'hubtiger-message-bundle',
        classId: 'rental-whatsapp-integration',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.whatsapp_integration',
        ),
        path: 'store/rentals/whatsapp-integration',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.text_message_integration'
        ),
        icon: 'hubtiger-message-bundle',
        classId: 'settings-messaging-integration',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.text_message_integration'
        ),
        path: 'store/text-message-platform-integration',
      },
    ];
  }

  setupGeneralOptions() {
    this.general = [
      {
        title: this.translate.instant('bikeshop.shop_setup.card_headers.users'),
        icon: 'hubtiger-profile',
        classId: 'rental-profile',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.users',
        ),
        //path: isDevMode() ? 'store/user-management' : 'store/users'
        path: 'store/rentals/user-management',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.manage_subscription',
        ),
        icon: 'hubtiger-cash',
        classId: 'rental-manage-subscription',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.manage_subscription',
        ),
        path: 'store/rentals/manage-subscription',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.shop_profile',
        ),
        icon: 'hubtiger-shop-profile',
        classId: 'rental-shop-profile',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.shop_profile',
        ),
        path: 'store/rentals/shop-profile',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.pos_setup',
        ),
        icon: 'hubtiger-settings',
        classId: 'rental-pos-setup',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.pos_setup',
        ),
        path: 'store/rentals/pos-integrations',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.pos_products',
        ),
        icon: 'hubtiger-pos',
        classId: 'rental-pos-products',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.pos_products',
        ),
        path: 'store/rentals/pos-products',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.rental_deliveries_and_collections',
        ),
        icon: 'hubtiger-pickup',
        classId: 'rental-deliveries-collections',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.rental_deliveries_and_collections',
        ),
        path: 'store/rentals/deliveries-and-collections',
      },      
    ];

    if (
      this.partner.POSSystemID === 6 ||
      this.partner.POSSystemID === 3 ||
      this.partner.POSSystemID === 8 ||
      this.partner.POSSystemID === 9 ||
      this.partner.POSSystemID === 11 ||
      this.partner.POSSystemID === 12 ||
      this.partner.POSSystemID === 13 ||
      this.partner.POSSystemID === 17 ||
      this.partner.POSSystemID === 19 ||
      this.partner.POSSystemID <= 0
    )
      this.general.push({
        title: this.translate.instant('bikeshop.menu.coupons'),
        icon: 'hubtiger-coupon',
        classId: 'rental-coupons',
        description: this.translate.instant(
          'bikeshop.menu.coupons_description',
        ),
        path: '/store/rentals/coupons',
      });
  }

  setupPluginsOptions() {
    this.plugins = [];
  }

  setupRentalsOptions() {
    this.rentals = [
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.rental_configuration',
        ),
        icon: 'hubtiger-wrench',
        classId: 'rental-configuration',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.rental_configuration',
        ),
        //path: isDevMode() ? 'store/user-management' : 'store/users'
        path: 'store/rentals/configuration',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.rental_time_configuration',
        ),
        icon: 'hubtiger-wrench',
        classId: 'rental-rental-time',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.rental_time_configuration',
        ),
        //path: isDevMode() ? 'store/user-management' : 'store/users'
        path: 'store/rentals/time-configuration',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.fixed_rental_config',
        ),
        icon: 'hubtiger-cash',
        classId: 'rental-fixed-config',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.fixed_rental_config',
        ),
        path: 'store/rentals/fixed-duration-rental-config',
        disabled: !this.configuration.allowFixedRentalOptions,
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.flexible_rental_config',
        ),
        icon: 'hubtiger-cash',
        classId: 'rental-flexible-config',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.flexible_rental_config',
        ),
        path: 'store/rentals/flexible-duration-rental-config',
        disabled: !this.configuration.allowFlexibleRentalOptions,
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.rental_categories',
        ),
        icon: 'hubtiger-pos',
        classId: 'rental-rental-categories',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.rental_categories',
        ),
        path: 'store/rentals/categories',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.rental_products_and_accessories',
        ),
        icon: 'hubtiger-pos',
        classId: 'rental-products-and-accessories',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.rental_products_and_accessories',
        ),
        path: 'store/rentals/products-accessories',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.custom_reservation_questions',
        ),
        icon: 'hubtiger-pos',
        classId: 'rental-questions',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.custom_rental_questions',
        ),
        path: 'store/rentals/custom-widget-questions',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.rental_affiliates',
        ),
        icon: 'hubtiger-shop-profile',
        classId: 'rental-affiliates',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.rental_affiliates',
        ),
        path: 'store/rentals/affiliates-configuration',
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.service_indicators',
        ),
        icon: 'hubtiger-shop-profile',
        classId: 'rental-service-indicators',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_headers.service_indicators',
        ),
        path: 'store/rentals/service-indicators-configuration'
      },
    ];    

    this.plugins.push({
      title: this.translate.instant(
        'bikeshop.shop_setup.card_headers.rentals_widget',
      ),
      icon: 'hubtiger-settings',
      classId: 'rental-widget',
      description: this.translate.instant(
        'bikeshop.shop_setup.card_description.rentals_widget',
      ),
      path: 'store/rentals-widget-configuration',
    });

    this.plugins.push({
      title: this.translate.instant(
        'bikeshop.shop_setup.card_headers.demos_widget',
      ),
      icon: 'hubtiger-settings',
      classId: 'rental-demo-widget',
      description: this.translate.instant(
        'bikeshop.shop_setup.card_description.demos_widget',
      ),
      path: 'store/demos-widget-configuration',
    });

    if (this.partner.Country == 'ZA') {
      this.rentals.push({
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.paystack_deposits',
        ),
        icon: 'hubtiger-cash',
        classId: 'rental-paystack-deposits',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.paystack_deposits',
        ),
        path: 'store/rentals/paystack-configuration',
      });
    }

    this.checkIfLinkedToStripeConnect();
  }

  checkIfLinkedToStripeConnect() {
    this.paymentService
      .checkPartnerLinkedStripeConnect(this.partner.ID)
      .subscribe(
        (result) => {
          if (result.linked) {
            this.rentals.push({
              title: this.translate.instant(
                'bikeshop.shop_setup.card_headers.long_term_payment_config',
              ),
              icon: 'hubtiger-cash',
              classId: 'rental-longterm-payment',
              description: this.translate.instant(
                'bikeshop.shop_setup.card_description.long_term_payment_config',
              ),
              path: 'store/rentals/long-term-payments-config',
              disabled: false,
            });
          }
        },
        (error) => {
          // this.rentals.push({
          //   title: this.translate.instant('bikeshop.shop_setup.card_headers.long_term_payment_config'),
          //   icon: 'hubtiger-cash',
          //   description: this.translate.instant('bikeshop.shop_setup.card_description.long_term_payment_config'),
          //   path: 'store/rentals/long-term-payments-config',
          //   disabled : true
          // })
        },
      );
  }
}
